import { FC, ReactNode } from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export interface FormActionsProps {
    onCancel?: () => void;
    onBack?: () => void;
    cancelLabel?: string;
    submitLabel?: string;
    backLabel?: string;
    isSubmitting?: boolean;
    disableSubmit?: boolean;
    children?: ReactNode;
    align?: 'left' | 'center' | 'right';
    sticky?: boolean;
}

export const FormActions: FC<FormActionsProps> = ({
    onCancel,
    onBack,
    cancelLabel = 'Cancel',
    submitLabel = 'Save',
    backLabel = 'Back',
    isSubmitting = false,
    disableSubmit = false,
    children,
    align = 'right',
    sticky = false,
}) => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent:
                    align === 'left'
                        ? 'flex-start'
                        : align === 'center'
                        ? 'center'
                        : 'flex-end',
                gap: 2,
                pt: 3,
                pb: sticky ? 3 : 0,
                px: sticky ? 3 : 0,
                ...(sticky && {
                    position: 'sticky',
                    bottom: 0,
                    backgroundColor: 'background.paper',
                    borderTop: '1px solid',
                    borderColor: 'divider',
                    zIndex: 10,
                    boxShadow: '0 -2px 8px rgba(0, 0, 0, 0.1)',
                }),
            }}
        >
            {onBack && (
                <Button
                    variant="outlined"
                    startIcon={<ArrowBackIcon />}
                    onClick={onBack}
                    disabled={isSubmitting}
                    sx={{
                        textTransform: 'none',
                        fontWeight: 500,
                    }}
                >
                    {backLabel}
                </Button>
            )}

            {onCancel && (
                <Button
                    variant="outlined"
                    startIcon={<CancelIcon />}
                    onClick={onCancel}
                    disabled={isSubmitting}
                    sx={{
                        textTransform: 'none',
                        fontWeight: 500,
                    }}
                >
                    {cancelLabel}
                </Button>
            )}

            {children}

            <Button
                type="submit"
                variant="contained"
                startIcon={isSubmitting ? <CircularProgress size={20} /> : <SaveIcon />}
                disabled={disableSubmit || isSubmitting}
                sx={{
                    textTransform: 'none',
                    fontWeight: 600,
                    minWidth: 120,
                }}
            >
                {isSubmitting ? 'Saving...' : submitLabel}
            </Button>
        </Box>
    );
};

